module.exports = __webpack_public_path__ + "img/adjust_home_icon3.02104e48.png";